import { useEffect, useState } from 'react';

import { getIsPhone } from '../utils/platform';

/**
 * `getIsPhone()` after mount. `ready` is false on the first render so
 * prerender and hydration match.
 */
export function useIsPhone(): { isPhone: boolean; ready: boolean } {
  const [isPhone, setIsPhone] = useState(false);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setIsPhone(getIsPhone());
    setReady(true);
  }, []);

  return { isPhone, ready };
}
